import { useMutation, useQueryClient } from "@tanstack/react-query";

import { getPatientPharmaciesApi } from "./getPatientPharmaciesApi";
import { patientPharmaciesQueryKey } from "./patientPharmaciesQueryKey";

export const useSetDefaultPatientPharmacy = (patientId?: string) => {
  const queryClient = useQueryClient();
  const api = getPatientPharmaciesApi(patientId);

  const { mutate: setDefaultPharmacyMutation, isPending } = useMutation({
    mutationFn: (pharmacyId: string) => api.setDefaultPharmacy(pharmacyId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: patientPharmaciesQueryKey(patientId),
      });
    },
  });

  return { setDefaultPharmacyMutation, isPending };
};
